<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="project.project_id && project.project_id > 0" @invoke-method="dbGetProject(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="project.project_id && project.project_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <template v-if="hasPerm('projects.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_project.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'projects' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-container grid-list-xl v-if="project != null">
                <v-layout row :wrap="$bp.smallScreen">
                    <v-flex xs12 md4 lg4 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                        <v-layout row wrap>
                            <v-flex xs12 pr-0 py-0>
                                <bc-tooltip class="ml-auto" perm="projects.update">
                                    <template slot="activator">
                                        <v-btn @click="openProjectDialog()" icon>
                                            <v-icon color="indigo">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    {{ $t("lang.modify_project") }}
                                </bc-tooltip>
                            </v-flex>
                            <v-flex py-1>
                                <p class="display-1 mb-0 text-xs-center">{{ project.project_name }}</p>
                                <p class="display-0 mb-0 text-xs-center">{{ project.company }}</p>
                            </v-flex>
                        </v-layout>
                        <v-divider class="my-0"></v-divider>

                        <!-- START INFO -->
                        <bc-list prepend-icon="info" prepend-position="top" perm="projects.update" icon-color="primary" font-size="12">
                            <template>
                                <v-container pa-2>
                                    <v-layout row wrap>
                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.start_date")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.start_date ? project.start_date : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.end_date")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.end_date ? project.end_date : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.serial_number")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.serial_number ? project.serial_number : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.model")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.model ? project.model : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.manufacture_date")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.manufacture_date ? project.manufacture_date : "---" }}</v-flex>
                                    </v-layout>
                                </v-container>
                            </template>
                        </bc-list>
                        <!-- END INFO -->

                        <v-divider class="my-0"></v-divider>

                        <!-- START CELL INFO -->
                        <bc-list prepend-icon="info" prepend-position="top" perm="projects.update" icon-color="primary" font-size="12">
                            <template>
                                <v-container pa-2>
                                    <v-layout row wrap>
                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.po_issue_date")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.po_issue_date ? project.po_issue_date : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.po_received_date")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.po_received_date ? project.po_received_date : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.customer_po")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.customer_po ? project.customer_po : "---" }}</v-flex>
                                    </v-layout>
                                </v-container>
                            </template>
                        </bc-list>
                        <!-- END CELL INFO -->
                        <v-divider class="my-0"></v-divider>
                        <bc-list prepend-icon="contacts" prepend-position="top" perm="projects.update" icon-color="primary" font-size="12">
                            <template>
                                <v-container pa-2>
                                    <v-layout row wrap>
                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.contact_name")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.contact_name ? project.contact_name : "---" }}</v-flex>

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.contact_email")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1
                                            ><span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{
                                                project.contact_email ? project.contact_email : "---"
                                            }}</span></v-flex
                                        >

                                        <v-flex xs6 fs-18 mt-1>{{ `${$t("lang.contact_phone")}:` }}</v-flex>
                                        <v-flex xs6 fs-18 fw-bold mt-1>{{ project.contact_phone ? project.contact_phone : "---" }}</v-flex>
                                    </v-layout>
                                </v-container>
                            </template>
                        </bc-list>

                        <!-- START NOTES -->
                        <!--<v-layout row wrap>
                                <v-flex xs12 py-2>
                                    <bc-notes-list
                                        :items="device.notes"
                                        perm="device.update"
                                        entity-object="Devices"
                                        :api-url="`devices/${this.$route.params.id}`"
                                        :scope="device.scope"
                                        state-property="device.notes"
                                    ></bc-notes-list>
                                </v-flex>
                            </v-layout>-->
                        <!-- END NOTES -->
                    </v-flex>
                    <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                    <v-flex xs12 md8 lg10 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start> </v-flex>
                </v-layout>
            </v-container>

            <bc-dialog :value="project_dialog" max-width="800">
                <v-card>
                    <v-form ref="formProject">
                        <v-card-title>
                            <span class="headline">{{ project.project_id ? $t("lang.edit_project") : $t("lang.add_project") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeProjectDialog"
                                :dialog-status="project_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <!-- <v-flex xs12>
                                        <v-text-field
                                            v-focus="project_dialog"
                                            v-model="project.project_id"
                                            :label="`${$t('lang.project_id')} *`"
                                            :counter="showCounter(project.project_id, 'projects.project_id')"
                                            :rules="ifValid('projects.project_id')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs6>
                                        <bc-autocomplete
                                            v-model="current_project.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="companies || []"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('projects.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.project_name"
                                            :label="`${$t('lang.project_name')} *`"
                                            :counter="showCounter(current_project.project_name, 'projects.project_name')"
                                            :rules="ifValid('projects.project_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.serial_number"
                                            :label="$t('lang.serial_number')"
                                            :counter="showCounter(current_project.serial_number, 'projects.serial_number')"
                                            :rules="ifValid('projects.serial_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.model"
                                            :label="$t('lang.model')"
                                            :counter="showCounter(current_project.model, 'projects.model')"
                                            :rules="ifValid('projects.model')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.contact_name"
                                            :label="$t('lang.contact_name')"
                                            :counter="showCounter(current_project.contact_name, 'projects.contact_name')"
                                            :rules="ifValid('projects.contact_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="current_project.manufacture_date"
                                            :label="$t('lang.manufacture_date')"
                                            :rules="ifValid('projects.manufacture_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.contact_email"
                                            :label="$t('lang.contact_email')"
                                            :counter="showCounter(current_project.contact_email, 'projects.contact_email')"
                                            :rules="ifValid('projects.contact_email')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.contact_phone"
                                            :label="$t('lang.contact_phone')"
                                            type="phone"
                                            mask="(###) ### - ####"
                                            :rules="ifValid('projects.contact_phone')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="current_project.start_date"
                                            :label="$t('lang.start_date')"
                                            :rules="ifValid('projects.start_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="current_project.end_date"
                                            :label="$t('lang.end_date')"
                                            :rules="ifValid('projects.end_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="current_project.po_issue_date"
                                            :label="$t('lang.po_issue_date')"
                                            :rules="ifValid('projects.po_issue_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="current_project.po_received_date"
                                            :label="$t('lang.po_received_date')"
                                            :rules="ifValid('projects.po_received_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="current_project.customer_po"
                                            :label="$t('lang.customer_po')"
                                            :counter="showCounter(current_project.customer_po, 'projects.customer_po')"
                                            :rules="ifValid('projects.customer_po')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-textarea
                                            v-model="current_project.notes"
                                            :label="$t('lang.notes')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('projects.notes')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="project.project_id" color="error" @mouseup.left="$refs.delete_projects.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeProjectDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveProjects">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <delete-confirmation-dialog
                ref="delete_project"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_project')"
                :message="$t('lang.delete_project_confirm')"
                @onConfirm="deleteProjects()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_project_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteProjectDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            project: {},
            current_project: {},
            file_name: "",
            dbGetProject: _.debounce(this.getProject, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            project_dialog: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchProject", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.projects) {
                        this.project = this.assignObj2(data.projects, this.rules_projects);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=project_status&sort_by=2",
                            method: "get",
                            stateProperty: "project_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "projects", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchProject", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.projects) {
                        next((vm) => {
                            vm.project = vm.assignObj2(data.projects, vm.rules_projects);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=project_status&sort_by=2",
                                method: "get",
                                stateProperty: "project_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "projects", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=project_status&sort_by=2",
            method: "get",
            stateProperty: "project_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_projects: (state) => state.projects.rules_projects,
            project_status_options: (state) => state.settings.project_status_options,
            projects: (state) => state.projects.projects,
            selectedProject: (state) => state.projects.selectedProject,
            companies: (state) => state.companies.company_options,
        }),
    },
    methods: {
        ...mapActions(["fetchProject", "saveProject", "deleteProject", "printProject", "fetchCustomers", "fetchCompanies"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getProject(pg_refresh = false) {
            this.startLoader();

            this.fetchProject({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.projects) {
                    this.project = this.assignObj2(data.projects, this.rules_projects);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printProject({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.project) {
                    if (this.dev_mode) {
                        this.file_name = data.project.file_name;
                    } else {
                        this.$refs.print.printReport(data.project.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveProjects() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formProject")) {
                    let body = this.prepForm(this.current_project, this.rules_projects);

                    this.saveProject({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.projects) {
                            this.project = this.assignObj2(data.projects, this.rules_projects);
                            this.toggleModalLoader(false);
                            this.validationOff();
                            this.finishLoader();
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { project_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveProjects({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.project) {
                    this.project = this.assignObj2(data.project, this.rules_projects);
                }
            });
        },
        deleteProjects() {
            this.deleteProject({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "projects" });
                }
                this.toggleModalLoader(false);
            });
        },
        openProjectDialog() {
            this.current_project = { ...this.project };
            this.project_dialog = true;
        },
        closeProjectDialog() {
            this.project_dialog = false;
            this.$refs.delete_project.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchProject({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.project) {
                        this.project = this.assignObj2(data.project, this.rules_projects);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.companies.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
